module.exports = __webpack_public_path__ + "static/img/designGuide6.a0a312e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/designGuide6.png
// module id = ktKW
// module chunks = 2